'use strict';

require('./onboarding.less');

angular.module('app')
    .component('angularOnboarding', {template: require('./onboarding.html')})
    .component('onboardingHello', {template: require('./onboarding-hello.html')})
    .component('onboardingStatus', {template: require('./onboarding-status.html'), controller: function (DataEnvironmentService, $scope, $state) {

        $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
        $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
        $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
        $scope.$state = $state;

    }})
;



// WEBPACK FOOTER //
// .-dna/app/components/onboarding/angular-components.js